import createContext from '@ant-design/create-react-context';
var RowContext = createContext({});
export default RowContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/grid/RowContext.js
// module id = 372
// module chunks = 0